module.exports = __webpack_public_path__ + "static/1-dc6ce99724e74735455e8596e21ccd80.png";